import { IFormatter } from '../FormatterTypes';
import { TEDDisplayTelNr } from '../Displayers/TEDDisplayTelNr';
import { TEDParseTelNr } from '../Parsers/TEDParseTelNr';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';

class TEDFormatTelNr implements IFormatter {
  displayer = TEDDisplayTelNr.getInstance();
  parser = TEDParseTelNr.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatTelNr };
